exports.components = {
  "component---src-pages-[id]-index-tsx": () => import("./../../../src/pages/[id]/index.tsx" /* webpackChunkName: "component---src-pages-[id]-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

